<template>
  <resource-edit-wrapper
    :title="$t('resources.categories.edit_page_category')"
    :need-modal="showModal"
    @saveAction="$refs['pageCategoryForm'].submit()">
    <PageCategoryForm
      is-edit
      :page-category="item"
      @isDirtyForm="isDirtyForm"
      ref="pageCategoryForm"></PageCategoryForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import PageCategoryForm from "@/components/forms/PageCategoryForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      PageCategoryForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
